export default __webpack_public_path__ + "static/media/icon_camera.86966072.svg";